import React, {  useEffect } from "react";
import { getPerfilEstablecimiento } from "../../Servicios/Servicios";
import { useSpinner } from "../spinner/spinner";

const BarCard = () => {
  const [nombreBar, setNombreBar] = React.useState("");
  const [numeroLike, setNumeroLike] = React.useState(0);
  const [imagen, setImagen] = React.useState("");
  const spinner = useSpinner();
  useEffect(() => {
    // Aquí puedes llamar a la función para obtener los detalles del bar
    getBarDetails();

  }, []);

  // Aquí puedes definir el estado y las funciones necesarias
  const getBarDetails = async () => {
    spinner.show();
    try {
      // Lógica para obtener detalles del bar, si es necesario  
      const getDetail = await getPerfilEstablecimiento();
      
      if (getDetail.success) {
        spinner.hide();
        let data = getDetail.data.resultados;
        setNombreBar(data.Nombre);
        setNumeroLike(data.numeroLikes);
        setImagen(data.Imagen);
        localStorage.setItem("idEstablecimiento", data.id);
        // alert("Detalles del bar obtenidos correctamente", getDetail.data.message);
        // Aquí puedes actualizar el estado con los detalles del bar
      }else {
        spinner.hide();
        alert("Error al obtener los detalles del bar: " + getDetail.message);
        setNombreBar("Bar no encontrado");
        setNumeroLike(0);
        setImagen("");
      }
    } catch (error) {
      spinner.hide();
      console.error("Error al obtener los detalles del bar:", error);
    }
  }

  return (
    <div id="CuadrosEstandar" style={{borderRadius:'16px', color:"white"}}>
      {/* Logo + Nombre */}
      <div className="flex items-center gap-3">
        {imagen && <img src={imagen} alt="Logo Bar" className="w-10 h-10 rounded-full object-cover" />}
        <span className="text-lg font-semibold">{nombreBar}</span>
      </div>

      {/* Seguidores + Dirección */}
      <div className="text-right text-sm leading-snug">
        <p>
          <span className="font-bold">{numeroLike}</span> <i className={`fas ${numeroLike ? "fa-thumbs-up" : "fa-heart-broken"}`}></i>
        </p>
        {/* <p >Calle 39 #21-101, Bogotá</p> */}
      </div>
    </div>
  );
};

export default BarCard;
